/**
 * Các loại hóa đơn
 */
export default {
  InvoiceWithCode: 1,
  InvoiceWithoutCode: 2,
};
